module.exports = __webpack_public_path__ + "static/media/join-in-img2-1.f65981c9.jpg";